import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NiceSelectModule } from "ng-nice-select";
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';

import { InvoicesRoutingModule } from '@teem/invoices-module/invoices-routing.module';
import { InvoicesHeaderComponent } from '@teem/invoices-module/components/invoices-header/invoices-header.component';
import { InvoicesTabHeaderComponent } from '@teem/invoices-module/components/invoices-tab-header/invoices-tab-header.component';
import { InvoiceListComponent } from '@teem/invoices-module/invoice-list.component';
import { CreateInvoiceComponent } from '@teem/invoices-module/forms/create-invoice/create-invoice.component';
// import { DeliverableComponent } from '@teem/invoices-module/forms/deliverable/deliverable.component';
import { PaymentInformationModal } from '@teem/invoices-module/modals/payment-information/payment-information.modal';
import { AdditionalInformationModal } from '@teem/invoices-module/modals/additional-information/additional-information.modal';
import { OnlinePaymentModal } from '@teem/invoices-module/modals/online-payment/online-payment.modal';
import { InvoicePreviewComponent } from '@teem/invoices-module/modals/invoice-preview/invoice-preview.component';
// import { EditInvoiceComponent } from '@teem/invoices-module/forms/edit-invoice/edit-invoice.component';
import { AddPaymentModalComponent } from '@teem/invoices-module/modals/add-payment-modal/add-payment-modal.component';
import { RecordPaymentModalComponent } from '@teem/invoices-module/modals/record-payment-modal/record-payment-modal.component';
import { QuickPaymentModalComponent } from '@teem/invoices-module/modals/quick-payment-modal/quick-payment-modal.component';
import { InvoiceLinkModalComponent } from '@teem/invoices-module/modals/invoice-link-modal/invoice-link-modal.component';
import { InvoiceQrCodeModalComponent } from '@teem/invoices-module/modals/invoice-qr-code-modal/invoice-qr-code-modal.component';
import { InvoiceRefModalComponent } from '@teem/invoices-module/modals/invoice-ref-modal/invoice-ref-modal.component';
import { AddClientModalComponent } from '@teem/invoices-module/modals/add-client-modal/add-client-modal.component';
import { AddItemsComponent } from '@teem/invoices-module/modals/add-items/add-items.component';
import { RecallInvoiceComponent } from '@teem/invoices-module/forms/recall-invoice/recall-invoice.component';
import { QrCodeModule } from 'ng-qrcode';

@NgModule({
  declarations: [
    InvoiceListComponent,
    InvoicesHeaderComponent,
    InvoicesTabHeaderComponent,
    CreateInvoiceComponent,
    // DeliverableComponent,/*this component copied from features/dashboard/component make same chnages made over here*/
    PaymentInformationModal,
    AdditionalInformationModal,
    OnlinePaymentModal,
    InvoicePreviewComponent,
    // EditInvoiceComponent,/*this component copied to features/dashboard/component make same chnages made over here*/
    AddPaymentModalComponent,
    RecordPaymentModalComponent,
    QuickPaymentModalComponent,
    InvoiceLinkModalComponent,
    InvoiceQrCodeModalComponent,
    InvoiceRefModalComponent,
    AddClientModalComponent,
    AddItemsComponent,
    RecallInvoiceComponent
  ],
  entryComponents: [
    PaymentInformationModal,
    AdditionalInformationModal,
    OnlinePaymentModal,
    InvoicePreviewComponent,
    RecordPaymentModalComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InvoicesRoutingModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    QrCodeModule
  ],
})
export class InvoicesModule { }
